/* eslint-disable jsx-a11y/accessible-emoji */
import React, { Component } from 'react';
import jQuery, { data } from 'jquery';
import { checkifWcSubscribedTrial, checkifLeadsReceived } from '../../API/FetchCall';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

import {AZ_ASSET_PATH } from '../../constant';

const IMGURL = "https://api.bewise.in/uploads/";

class BeWise_SideBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user_name: '',
            logged: localStorage.getItem("authentication"),
            auth_data: JSON.parse(localStorage.getItem("user_data")),
            iswiseconnectsubscribed:true,
            wcallowedtoacess:true,
            wcneedextension:false,
            haveleads:false,
            totalleads:0
        };
        
        this.checkifLeadsReceived = this.checkifLeadsReceived.bind(this);

    }

    componentDidMount() {
        let dataOfUser = this.state.auth_data;
        let allowedtoacess = (dataOfUser.upgraded==1)?true:(dataOfUser.current_plan!=5 && dataOfUser.current_plan!=0  && dataOfUser.current_plan!=1)?true:false;
        this.setState({user_name:this.state.auth_data.user_name, role:this.state.auth_data.role, allowedtoacess:allowedtoacess});


        if(dataOfUser.user_type===1){
            this.checkifWcSubscribedTrial();
        }

        if(dataOfUser.role===3){
          this.checkifLeadsReceived();
        }
        

    }

    checkifLeadsReceived(){

      let insdata = JSON.stringify({
        vendor_id: this.state.auth_data.login_id
      })
  
      checkifLeadsReceived(insdata).then((response) => {
        if (response.status === 1) {
          if(response.total>0)
            this.setState({haveleads:true, totalleads:response.total});   
          else
            this.setState({haveleads:false});  
        }
        
      });

    }    

    checkifWcSubscribedTrial(){

      let insdata = JSON.stringify({
        vendor_id: this.state.auth_data.login_id
      })
  
      checkifWcSubscribedTrial(insdata).then((response) => {
        if (response.status === 1) {
          this.setState({wcallowedtoacess:true});   
        }
        else{

          let dataOfUser = this.state.auth_data;

          if(dataOfUser.upgraded_plan=="bwvwc"){
            this.setState({wcallowedtoacess:true});   
          }else{
            this.setState({wcallowedtoacess:false});
          }

           
        }
      });

    }

    showNoaccess(){

      NotificationManager.error('Please subscribe or upgrade your subscription');
    }

    render() {

        const profilepicture = (this.state.auth_data.profilepicture)?this.state.auth_data.profilepicture:'';
 
        //console.log(profilepicture)
        return (

        <React.Fragment>
         
        <nav class="sidebar sidebar-offcanvas" id="sidebar">
        <ul class="nav">
          <li class="nav-item">
            <div class="d-flex sidebar-profile" >
              <div class="sidebar-profile-image">
              { (profilepicture==undefined || profilepicture=='') && 
                <i class="fa fa-user" aria-hidden="true"></i>
              }
              { (profilepicture!=undefined && profilepicture!='') && 
                <img src={AZ_ASSET_PATH+profilepicture} alt="image" />
              }
              </div>
              <div class="sidebar-profile-name">
                <p class="sidebar-designation">
                  welcome 
                  <span class="loggeduserdisplay">{this.state.user_name}</span>
                </p>
              </div>
            </div>
         
          </li>


          {this.state.role==10 && (
            
            <React.Fragment>

            <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#dashboard" aria-expanded="false" aria-controls="form-elements">
              <i class="typcn typcn-film menu-icon"></i>
              <span class="menu-title">Dashboard</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="dashboard">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"><a class="nav-link" id="dashboard" href="/dashboard/dashboard">Dashboard</a></li>
                <li class="nav-item"><a class="nav-link" id="reportsparents" href="/dashboard/reportsparents">Report (Parents)</a></li>
              </ul>
            </div>
            </li>


            <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#categories" aria-expanded="false" aria-controls="form-elements">
              <i class="typcn typcn-film menu-icon"></i>
              <span class="menu-title">Verticals</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="categories">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"><a class="nav-link" id="school" href="/vertical/school">Schools</a></li>
                <li class="nav-item"><a class="nav-link" id="preschool" href="/vertical/preschool">Preschools</a></li>
                <li class="nav-item"><a class="nav-link" id="tuitions" href="/vertical/tuitions">Tuitions</a></li>
                <li class="nav-item"><a class="nav-link" id="afterschoolactivities" href="/vertical/afterschoolactivities">After School Activities</a></li>
                <li class="nav-item"><a class="nav-link" id="kidsplayarea" href="/vertical/kidsplayarea">Kids Play Area</a></li>
                <li class="nav-item"><a class="nav-link" id="learningcamps" href="/vertical/learningcamps">Learning Camps</a></li>
                <li class="nav-item"><a class="nav-link" id="communitysupports" href="/vertical/communitysupports">Community Supports</a></li>
                <li class="nav-item"><a class="nav-link" id="birthdayevents" href="/vertical/birthdayevents">Birthday Events</a></li>
              </ul>
            </div>
            </li>

           

          
          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#leads" aria-expanded="false" aria-controls="leads">
              <i class="typcn typcn-group-outline menu-icon"></i>
              <span class="menu-title">Leads</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="leads">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"> <a class="nav-link" id="leadlist" href="/leads/leadlist"> List </a></li>
                
              </ul>
            </div>
          </li>

                 

            </React.Fragment>
          )
          
          }
           
          {this.state.role!=1 && this.state.role!=2 && this.state.role!=3 && this.state.role !=11 && this.state.role !=10 && this.state.role!=15 && (
            
            <React.Fragment>

            <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#dashboard" aria-expanded="false" aria-controls="form-elements">
              <i class="typcn typcn-film menu-icon"></i>
              <span class="menu-title">Dashboard</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="dashboard">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"><a class="nav-link" id="dashboard" href="/dashboard/dashboard">Dashboard</a></li>
                
              </ul>
            </div>
            </li>


            <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#categories" aria-expanded="false" aria-controls="form-elements">
              <i class="typcn typcn-film menu-icon"></i>
              <span class="menu-title">Verticals</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="categories">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"><a class="nav-link" id="school" href="/vertical/school">Schools</a></li>
                <li class="nav-item"><a class="nav-link" id="preschool" href="/vertical/preschool">Preschools</a></li>
                <li class="nav-item"><a class="nav-link" id="tuitions" href="/vertical/tuitions">Tuitions</a></li>
                <li class="nav-item"><a class="nav-link" id="afterschoolactivities" href="/vertical/afterschoolactivities">After School Activities</a></li>
                <li class="nav-item"><a class="nav-link" id="kidsplayarea" href="/vertical/kidsplayarea">Kids Play Area</a></li>
                <li class="nav-item"><a class="nav-link" id="learningcamps" href="/vertical/learningcamps">Learning Camps</a></li>
                <li class="nav-item"><a class="nav-link" id="communitysupports" href="/vertical/communitysupports">Community Supports</a></li>
                <li class="nav-item"><a class="nav-link" id="birthdayevents" href="/vertical/birthdayevents">Birthday Events</a></li>
              </ul>
            </div>
            </li>

            <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#tables" aria-expanded="false" aria-controls="tables">
              <i class="typcn typcn-th-small-outline menu-icon"></i>
              <span class="menu-title">Content Management</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="tables">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"> <a class="nav-link" id="insights" href="/cms/insights">Articles</a></li>
                <li class="nav-item"> <a class="nav-link" id="events" href="/cms/events">Events</a></li>
                <li class="nav-item"> <a class="nav-link" id="sitecontents" href="/cms/sitecontents">Site Contents</a></li>
                <li class="nav-item"> <a class="nav-link" id="mails" href="/cms/mails">Mail Contents</a></li>
                <li class="nav-item"> <a class="nav-link" id="websiteads" href="/cms/websiteads"> Website Ads </a></li>
              </ul>
            </div>
          </li>

          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#duplicates" aria-expanded="false" aria-controls="duplicates">
              <i class="typcn typcn-group-outline menu-icon"></i>
              <span class="menu-title">Duplicates</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="duplicates">
              <ul class="nav flex-column sub-menu">
              <li class="nav-item"> <a class="nav-link" id="duplicateinschool" href="/duplicates/duplicateinschool"> School </a></li>
                <li class="nav-item"> <a class="nav-link" id="duplicateinpreschool" href="/duplicates/duplicateinpreschool"> Preschool </a></li>
                <li class="nav-item"> <a class="nav-link" id="duplicateintuition" href="/duplicates/duplicateintuition"> Tuition </a></li>
                <li class="nav-item"> <a class="nav-link" id="duplicateinafterschool" href="/duplicates/duplicateinafterschool"> After School Activities </a></li>
                <li class="nav-item"> <a class="nav-link" id="duplicateinkidsplayarea" href="/duplicates/duplicateinkidsplayarea"> Kids Play Area </a></li>
                <li class="nav-item"> <a class="nav-link" id="duplicateinlearningcamps" href="/duplicates/duplicateinlearningcamps"> Learning Camps </a></li>
                <li class="nav-item"> <a class="nav-link" id="duplicateincommunity" href="/duplicates/duplicateincommunity"> Community </a></li>
              </ul>
            </div>
          </li>

          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#leads" aria-expanded="false" aria-controls="leads">
              <i class="typcn typcn-group-outline menu-icon"></i>
              <span class="menu-title">Leads</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="leads">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"> <a class="nav-link" id="leadlist" href="/leads/leadlist"> List </a></li>
                
              </ul>
            </div>
          </li>

          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#wiseconnect" aria-expanded="false" aria-controls="wiseconnect">
              <i class="typcn typcn-group-outline menu-icon"></i>
              <span class="menu-title">WiseConnect</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="wiseconnect">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"> <a class="nav-link" id="subscriberslist" href="/wiseconnect/subscriberslist"> Subscribers List </a></li>
                
              </ul>
            </div>
          </li>
 
          

            </React.Fragment>
          )
          
          }
 

          { /* Super Admin */ }
          {this.state.role==1 && (

          <React.Fragment>
          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#dashboard" aria-expanded="false" aria-controls="form-elements">
              <i class="typcn typcn-film menu-icon"></i>
              <span class="menu-title">Dashboard</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="dashboard">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"><a class="nav-link" id="dashboard" href="/dashboard/dashboard">Dashboard</a></li>
                <li class="nav-item"><a class="nav-link" id="reports" href="/dashboard/reports">Reports</a></li>
              </ul>
            </div>
          </li>
          
          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#categories" aria-expanded="false" aria-controls="form-elements">
              <i class="typcn typcn-film menu-icon"></i>
              <span class="menu-title">Verticals</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="categories">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"><a class="nav-link" id="school" href="/vertical/school">Schools</a></li>
                <li class="nav-item"><a class="nav-link" id="preschool" href="/vertical/preschool">Preschools</a></li>
                <li class="nav-item"><a class="nav-link" id="tuitions" href="/vertical/tuitions">Tuitions</a></li>
                <li class="nav-item"><a class="nav-link" id="afterschoolactivities" href="/vertical/afterschoolactivities">After School Activities</a></li>
                <li class="nav-item"><a class="nav-link" id="kidsplayarea" href="/vertical/kidsplayarea">Kids Play Area</a></li>
                <li class="nav-item"><a class="nav-link" id="learningcamps" href="/vertical/learningcamps">Learning Camps</a></li>
                <li class="nav-item"><a class="nav-link" id="communitysupports" href="/vertical/communitysupports">Community Supports</a></li>
                <li class="nav-item"><a class="nav-link" id="birthdayevents" href="/vertical/birthdayevents">Birthday Events</a></li>
                <li class="nav-item"> <a class="nav-link" id="bewisecuratedcamps" href="/admin/bewisecuratedcamps"> BeWise Curated Camps </a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#users" aria-expanded="false" aria-controls="ui-basic">
              <i class="typcn typcn-briefcase menu-icon"></i>
              <span class="menu-title">User Management</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="users">
              <ul class="nav flex-column sub-menu">
                
                <li class="nav-item"> <a class="nav-link" id="partners"  href="/users/partners">Partners</a></li>
                <li class="nav-item"> <a class="nav-link" id="parents"  href="/users/parents">Parents</a></li>  
                <li class="nav-item"> <a class="nav-link" id="exclusivepartners"  href="/users/exclusivepartners">Exclusive Partnerships</a></li>
                <li class="nav-item"> <a class="nav-link" id="bewiseusers"  href="/users/bewiseusers">BeWise Users</a></li>
              
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#charts" aria-expanded="false" aria-controls="charts">
              <i class="fa fa-money menu-icon"></i>
              <span class="menu-title">Payments</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="charts">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"> <a class="nav-link" id="transactions" href="/payments/transactions">Transactions</a></li>
                <li class="nav-item"> <a class="nav-link" id="paymentlinks" href="/payments/paymentlinks">RazorPay PaymentLinks</a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#tables" aria-expanded="false" aria-controls="tables">
              <i class="typcn typcn-th-small-outline menu-icon"></i>
              <span class="menu-title">Content Management</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="tables">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"> <a class="nav-link" id="insights" href="/cms/insights">Articles</a></li>
                <li class="nav-item"> <a class="nav-link" id="events" href="/cms/events">Events</a></li>
                <li class="nav-item"> <a class="nav-link" id="sitecontents" href="/cms/sitecontents">Site Contents</a></li>
                <li class="nav-item"> <a class="nav-link" id="mails" href="/cms/mails">Mail Contents</a></li>
                <li class="nav-item"> <a class="nav-link" id="websiteads" href="/cms/websiteads"> Website Ads </a></li>
              </ul>
            </div>
          </li>

          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#duplicates" aria-expanded="false" aria-controls="duplicates">
              <i class="typcn typcn-group-outline menu-icon"></i>
              <span class="menu-title">Duplicates</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="duplicates">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"> <a class="nav-link" id="duplicateinschool" href="/duplicates/duplicateinschool"> School </a></li>
                <li class="nav-item"> <a class="nav-link" id="duplicateinpreschool" href="/duplicates/duplicateinpreschool"> Preschool </a></li>
                <li class="nav-item"> <a class="nav-link" id="duplicateintuition" href="/duplicates/duplicateintuition"> Tuition </a></li>
                <li class="nav-item"> <a class="nav-link" id="duplicateinafterschool" href="/duplicates/duplicateinafterschool"> After School Activities </a></li>
                <li class="nav-item"> <a class="nav-link" id="duplicateinkidsplayarea" href="/duplicates/duplicateinkidsplayarea"> Kids Play Area </a></li>
                <li class="nav-item"> <a class="nav-link" id="duplicateinlearningcamps" href="/duplicates/duplicateinlearningcamps"> Learning Camps </a></li>
                <li class="nav-item"> <a class="nav-link" id="duplicateincommunity" href="/duplicates/duplicateincommunity"> Community </a></li>

              </ul>
            </div>
          </li>
          
          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#leads" aria-expanded="false" aria-controls="leads">
              <i class="typcn typcn-group-outline menu-icon"></i>
              <span class="menu-title">Leads</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="leads">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"> <a class="nav-link" id="leadlist" href="/leads/leadlist"> List </a></li>
                <li class="nav-item"> <a class="nav-link" id="stats" href="/leads/stats"> Stats </a></li>
              </ul>
            </div>
          </li>

          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#enquiries" aria-expanded="false" aria-controls="leads">
              <i class="typcn typcn-group-outline menu-icon"></i>
              <span class="menu-title">Enquiries</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="enquiries">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"> <a class="nav-link" id="leadlist" href="/enquiry/enquiries"> List </a></li>
                
              </ul>
            </div>
          </li>


          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#wiseconnect" aria-expanded="false" aria-controls="wiseconnect">
              <i class="typcn typcn-group-outline menu-icon"></i>
              <span class="menu-title">WiseConnect</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="wiseconnect">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"> <a class="nav-link" id="registeredusers" href="/wiseconnect/registeredusers"> Registered Users </a></li>
                <li class="nav-item"> <a class="nav-link" id="newslettersubscribers" href="/wiseconnect/newslettersubscribers"> Newsletter Subscibers </a></li>
                <li class="nav-item"> <a class="nav-link" id="courses" href="/wiseconnect/courses"> Courses </a></li>
                <li class="nav-item"> <a class="nav-link" id="othercourses" href="/wiseconnect/othercourses"> Other Courses </a></li>
                <li class="nav-item"> <a class="nav-link" id="jobs" href="/wiseconnect/jobs">Jobs</a></li>
                <li class="nav-item"> <a class="nav-link" id="externalblogs" href="/wiseconnect/externalblogs">External Blogs</a></li>
              </ul>
            </div>
          </li>

          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#excsingups" aria-expanded="false" aria-controls="excsingups">
              <i class="typcn typcn-group-outline menu-icon"></i>
              <span class="menu-title">Exclusive Signups</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="excsingups">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"> <a class="nav-link" id="auroscholars" href="/exclsignups/auroscholars"> AuroScholar </a></li>
                
              </ul>
            </div>
          </li>


          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#general" aria-expanded="false" aria-controls="general">
              <i class="typcn typcn-info-outline menu-icon"></i>
              <span class="menu-title">Universal Content</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="general">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"> <a class="nav-link" id="localities" href="/general/localities"> Localities </a></li>
                <li class="nav-item"> <a class="nav-link" id="cities" href="/general/cities"> Cities </a></li>
                <li class="nav-item"> <a class="nav-link" id="contacts" href="/general/contacts"> Contacts </a></li>
                <li class="nav-item"> <a class="nav-link" id="images" href="/general/images"> Images </a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#settings" aria-expanded="false" aria-controls="settings">
              <i class="typcn typcn-cog-outline menu-icon"></i>
              <span class="menu-title">Admin Access</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="settings">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"> <a class="nav-link" id="roles" href="/admin/roles"> Role </a></li>
                <li class="nav-item"> <a class="nav-link" id="gst" href="/admin/gst"> GST </a></li>
                <li class="nav-item"> <a class="nav-link" id="packages" href="/admin/packages"> Packages </a></li>
                <li class="nav-item"> <a class="nav-link" id="promocode" href="/admin/promocode"> Promo Codes </a></li>
                <li class="nav-item"> <a class="nav-link" id="eventresources" href="/admin/eventresources"> Event Resources </a></li>
                <li class="nav-item"> <a class="nav-link" id="custommails" href="/admin/custommails"> Send Mail </a></li>
              </ul>
            </div>
          </li>

          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#trash" aria-expanded="false" aria-controls="trash">
              <i class="typcn typcn-trash menu-icon"></i>
              <span class="menu-title">Trash</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="trash">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"> <a class="nav-link" id="trash" href="/trash/partners"> Partners </a></li>
                 

              </ul>
            </div>
          </li>

          </React.Fragment>
          )
          
          }


          {this.state.role==3 && (

          <React.Fragment>
          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#dashboard" aria-expanded="false" aria-controls="form-elements">
              <i class="typcn typcn-film menu-icon"></i>
              <span class="menu-title">Dashboard</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="dashboard">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"><a class="nav-link" id="dashboard" href="/partner/dashboard">Dashboard</a></li>
                {this.state.allowedtoacess && 
                <li class="nav-item"><a class="nav-link" id="reports" href="/partner/reports">Reports</a></li>
                }
                {!this.state.allowedtoacess &&
                <li class="nav-item"  onClick={this.showNoaccess}><a class="nav-link" id="reports" href="#">Reports</a></li>
                }
              </ul>
            </div>
          </li>
          
          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#categories" aria-expanded="false" aria-controls="form-elements">
              <i class="typcn typcn-film menu-icon"></i>
              <span class="menu-title">My Account</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="categories">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"><a class="nav-link" id="profile" href="/partner/profile">Profile</a></li>
                <li class="nav-item"><a class="nav-link" id="accountinfo" href="/partner/accountinfo">Account info</a></li>
                
                
                
                
                {this.state.allowedtoacess &&      
                <li class="nav-item"> <a class="nav-link" id="benchmarking" href="/partner/benchmarking">Benchmarking</a></li>
                }
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#users" aria-expanded="false" aria-controls="ui-basic">
              <i class="typcn typcn-briefcase menu-icon"></i>
              <span class="menu-title">Subscriptions</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="users">
              <ul class="nav flex-column sub-menu">
                
                <li class="nav-item"> <a class="nav-link" id="subscriptioninfo"  href="/partner/subscriptioninfo">Subscription info</a></li>
                
              </ul>
            </div>
          </li>

          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#leads" aria-expanded="false" aria-controls="leads">
              <i class="typcn typcn-group-outline menu-icon"></i>
              <span class="menu-title">Leads</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="leads">
               
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"> <a class="nav-link" id="leadlist" href="/leads/leadlist"> List </a></li>
              </ul>
               
            </div>
          </li>

          
          {!this.state.allowedtoacess &&
              <li class="nav-item" onClick={this.showNoaccess}> 
              <a class="nav-link" id="review" href="#">
                <i class="typcn typcn-pen menu-icon"></i>
                <span class="menu-title">Parents Feedback</span>
              </a>
              </li>
          }

          {this.state.allowedtoacess &&

              <li class="nav-item"> 
              <a class="nav-link" id="review" href="/partner/review">
                <i class="typcn typcn-pen menu-icon"></i>
                <span class="menu-title">Parents Feedback</span>
              </a>
              </li>
          }  
          {!this.state.allowedtoacess &&
          <li class="nav-item" onClick={this.showNoaccess}> <a class="nav-link" id="exclusivepartnerships" href="#">
            <i class="typcn typcn-starburst menu-icon"></i><span class="menu-title">Curated Partnerships</span></a>
          </li>
          }
          {this.state.allowedtoacess &&
          <li class="nav-item"> <a class="nav-link" id="exclusivepartnerships" href="/partner/exclusivepartnerships">
            <i class="typcn typcn-starburst menu-icon"></i><span class="menu-title">Curated Partnerships</span></a>
          </li>
          }

          <li class="nav-item"> <a class="nav-link" id="articles" href="/partner/articles">
          <i class="typcn typcn-document-text menu-icon"></i>
              <span class="menu-title">Articles</span>
            
            </a></li>

          {this.state.iswiseconnectsubscribed && 
          <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#wiseconnect" aria-expanded="false" aria-controls="wiseconnect">
              <i class="typcn typcn-th-small-outline menu-icon"></i>
              <span class="menu-title">WiseConnect</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="wiseconnect">
              {!this.state.wcallowedtoacess &&
                  <span class="upgradetextinfo">Please subscribe or upgrade your subscription</span>
              }  
              {this.state.wcallowedtoacess &&
              <ul class="nav flex-column sub-menu">
                
                  <li class="nav-item"> <a class="nav-link" id="wcdashboard" href="/partner/wcdashboard">Dashboard</a></li>
                  <li class="nav-item"> <a class="nav-link" id="wcpostajob" href="/partner/wcpostajob">Post job</a></li>
                  <li class="nav-item"> <a class="nav-link" id="wctalentsearch" href="/partner/wctalentsearch">Talent Search</a></li>
                   
                  <li class="nav-item"> <a class="nav-link" id="wcadvisory" href="/partner/wcadvisory">Advisory</a></li>
              </ul>
              }
            </div>
          </li>
          }
           

           </React.Fragment>
          )
          
          }

{this.state.role==11 && (

<React.Fragment>
<li class="nav-item">
  <a class="nav-link" data-toggle="collapse" href="#dashboard" aria-expanded="false" aria-controls="form-elements">
    <i class="typcn typcn-film menu-icon"></i>
    <span class="menu-title">Dashboard</span>
    <i class="menu-arrow"></i>
  </a>
  <div class="collapse" id="dashboard">
    <ul class="nav flex-column sub-menu">
      <li class="nav-item"><a class="nav-link" id="dashboard" href="/exclusiveparnter/dashboard">Dashboard</a></li>
     
    </ul>
  </div>
</li>

 </React.Fragment>
)

}

{this.state.role==15 && (

<React.Fragment>
<li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#categories" aria-expanded="false" aria-controls="form-elements">
              <i class="typcn typcn-film menu-icon"></i>
              <span class="menu-title">Verticals</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="categories">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"><a class="nav-link" id="school" href="/vertical/school">Schools</a></li>
                <li class="nav-item"><a class="nav-link" id="preschool" href="/vertical/preschool">Preschools</a></li>
                <li class="nav-item"><a class="nav-link" id="tuitions" href="/vertical/tuitions">Tuitions</a></li>
                <li class="nav-item"><a class="nav-link" id="afterschoolactivities" href="/vertical/afterschoolactivities">After School Activities</a></li>
                <li class="nav-item"><a class="nav-link" id="kidsplayarea" href="/vertical/kidsplayarea">Kids Play Area</a></li>
                <li class="nav-item"><a class="nav-link" id="learningcamps" href="/vertical/learningcamps">Learning Camps</a></li>
                <li class="nav-item"><a class="nav-link" id="communitysupports" href="/vertical/communitysupports">Community Supports</a></li>
                <li class="nav-item"><a class="nav-link" id="birthdayevents" href="/vertical/birthdayevents">Birthday Events</a></li>
                <li class="nav-item"> <a class="nav-link" id="bewisecuratedcamps" href="/admin/bewisecuratedcamps"> BeWise Curated Camps </a></li>
              </ul>
            </div>
</li>


<li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#wiseconnect" aria-expanded="false" aria-controls="wiseconnect">
              <i class="typcn typcn-group-outline menu-icon"></i>
              <span class="menu-title">WiseConnect</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="wiseconnect">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"> <a class="nav-link" id="registeredusers" href="/wiseconnect/registeredusers"> Registered Users </a></li>
              </ul>
            </div>
          </li>

 </React.Fragment>
)

}



        </ul>
        
        </nav>
        <NotificationContainer/>
            </React.Fragment>

        )
    }
}


export default BeWise_SideBar;


// WEBPACK FOOTER //
// ./src/components/bewise/sideBar.jsx